import * as React from "react";
import styled, { css } from "styled-components";
import OriginalButtonGroup from "./ButtonGroup";
const StyledButtonToolbar = styled(OriginalButtonGroup)(
  ({ theme }) => css`
    gap: ${theme.spacings.xs};
  `
);
const ButtonToolbar = React.forwardRef(
  ({ ...props }, ref) => /* @__PURE__ */ React.createElement(StyledButtonToolbar, { ref, ...props })
);
export default ButtonToolbar;
